module.exports = __webpack_public_path__ + "img/din-approved.bca81935.jpg";